import React from 'react';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Actions, Toast, API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Client } from 'models/ClientModel';
import { Communication } from 'models/CommunicationModel';

const FamilyCommunication: React.FC = () => {
  const width = { id: 15, client: 35, dob: 20, age: 20 }
  const [formId, formName] = [Code.Form.Id.COMMUNICATION, Code.Form.Name.COMMUNICATION];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab("family"));
  const [formData, setFormData] = useState<Client>({});
  const [communicationData, setCommunicationData] = useState<Communication[]>([]); 
    
  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasOpen(Privilege);
  
  useEffect(() => {
     API.Data.GetByKeyId<Client>(Code.Form.Name.CLIENT, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        const formData = await Form.Map.Data(data);
        setFormData((prevData) => ({
          ...prevData,
          ...formData,
        }));

        const contactItems: string[] = [];
        if (data.client_phone && data.client_phone.length == 10) contactItems.push(data.client_phone);
        if (data.client_cell && data.client_cell.length == 10) contactItems.push(data.client_cell);
        if (data.client_mobile && data.client_mobile.length == 10) contactItems.push(data.client_mobile);
        if (data.client_email && Utility.isValid.Email(data.client_email)) contactItems.push(data.client_email);
        if (data.client_fax && data.client_fax.length == 10) contactItems.push(data.client_fax);

        getCommunicationList(contactItems.join(","));
      }})
      setLoading(false);
  }, []);

  const getCommunicationList = async (contactList: string) => {
      console.log("contactList:",contactList);
      if (!contactList || contactList.length>0) return;  
        const url = API.Build.FormApiEndpint(Code.Form.Name.COMMUNICATION, 0, Name.Communication.Id, Code.Option.Sort.ASC, {
        fields: Utility.Join.Fields([
          Name.Communication.Id, 
          Name.Communication.Date,
          Name.Communication.Body
        ]),
        [Name.Communication.Contact]: `in:${contactList}`,
      });
      await API.Data.List<Communication>(url, setCommunicationData, setError, setLoading);
   };


  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef}>
          <Button.Top formName='Communication' />
          <Control.Tab.Header titles={["Communication"]} activeTab={activeTab} formName={"Communication"} setActiveTab={setActiveTab} />
          <Control.Form.Data>
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <div className='comm-frame'>
                {communicationData.length}
                {communicationData.map((communication, index) => { return (
                  <div>
                    <span>{communication.communication_date?.toString()}</span>
                    <p>{communication.communication_body}</p>
                  </div>
                )})}
              </div>
            </Control.Tab.Content>
          </Control.Form.Data>
        </form>
      )}
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default FamilyCommunication;